var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ding-zhen-que"},[_c('dl',[_c('dt',[_vm._v("学员正在参与普通答题互动")]),_c('dd',[_vm._v(_vm._s(_vm.countdownDesc))])]),_c('ClassBtn',{on:{"realEnd":_vm.realEnd,"end":_vm.end}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }